import styled from 'styled-components';
import { borderRadius, compose, fontSize, space } from 'styled-system';
import { borderRadiusAttrs } from '../utils/attrs';
import { applyVariations, getPaletteColor } from '../utils/utils';
/**
 * @public
 */
export const ToggleBadge = /*#__PURE__*/styled.button.attrs(borderRadiusAttrs).withConfig({
  displayName: "ToggleBadge",
  componentId: "sc-1jzer4c-0"
})(["border-radius:", ";border:0;display:inline-block;font-weight:", ";font-family:inherit;cursor:pointer;background-color:", ";color:", ";&:hover{background-color:", ";}", " ", ""], props => props.theme.radius, props => props.theme.bold, props => props.selected ? getPaletteColor(props.bg || props.color, 'light')(props) : props.unSelectedBg, getPaletteColor('base'), props => getPaletteColor(props.bg || props.color, 'light')(props), applyVariations('ToggleBadge'), props => compose(space, fontSize, borderRadius)(props));
ToggleBadge.displayName = 'ToggleBadge';
ToggleBadge.defaultProps = {
  borderRadius: 'full',
  selected: false,
  px: 2,
  py: 1,
  mx: 1,
  my: 1,
  fontSize: 0,
  color: 'primary',
  unSelectedBg: 'transparent'
};